export default __webpack_public_path__ + "static/media/pourbus_02.dbdcf930.jpg";